import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";

export function useMyBoards(limit?: number) {
  return useQuery({
    queryKey: limit ? ([...queryKeys.myBoards, { limit }] as const) : queryKeys.myBoards,
    queryFn: () => api.listMyBoards(limit),
  });
}
